angular.module('tf.services')

    .service('BackButtonService', ['$rootScope','$state','BreadCrumbsService', function ($rootScope, $state, BreadCrumbsService) {


        function hasBack() {
            return  BreadCrumbsService.get().length > 2;
        }
        this.showBack = function(){
            return _.includes(['app.folder','app.project'], $state.current.name);
        };

        this.back = function () {
            if(hasBack()){
                var state = BreadCrumbsService.last();
                $state.go('app.folder', {path: state.url}, {location : 'replace'});
            } else {
                $state.go('app.farmers', null, {location : 'replace'});
            }

        };




        return this;
    }])
;
